export enum actionTypes {
    FETCH_DCDD_TOTAL_USER_REQUEST = 'FETCH_DCDD_TOTAL_USER_REQUEST',
    FETCH_DCDD_TOTAL_USER_SUCCESS = 'FETCH_DCDD_TOTAL_USER_SUCCESS',
    FETCH_DCDD_TOTAL_USER_FAIL = 'FETCH_DCDD_TOTAL_USER_FAIL',
    FETCH_DCDD_TOTAL_USER_BY_FILTER_REQUEST = 'FETCH_DCDD_TOTAL_USER_BY_FILTER_REQUEST',
    FETCH_DCDD_TOTAL_USER_BY_FILTER_SUCCESS = 'FETCH_DCDD_TOTAL_USER_BY_FILTER_SUCCESS',
    FETCH_DCDD_TOTAL_USER_BY_FILTER_FAIL = 'FETCH_DCDD_TOTAL_USER_BY_FILTER_FAIL',
    RESET_DCDD_FILTER_DATA = 'RESET_DCDD_FILTER_DATA'
}


export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface DcddTotalUserProps{
    total_new:number
    total_all:number
    total_active:number
}
export interface DcddTotalUserDataInput {
  from_date: string | null;
  to_date: string | null;
  dzongkhag_id: string | null;
  category: string | null;
  eccd_id: string | null;
  school_id: string | null;
}

export interface CommercialTotalUserDataInput{
    from_date:string,
    to_date:string,
}

export interface FetchDcddTotalUserRequestAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_REQUEST;
}

export interface FetchDcddTotalUserSuccessAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_SUCCESS;
    payload: DcddTotalUserProps;
}

export interface FetchDcddTotalUserFailureAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_FAIL;
    payload: string;
}
export interface FetchDcddTotalUserByFilterRequestAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_REQUEST;
}

export interface FetchDcddTotalUserByFilterSuccessAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_SUCCESS;
    payload: DcddTotalUserProps;
}

export interface FetchDcddTotalUserByFilterFailureAction {
    type: actionTypes.FETCH_DCDD_TOTAL_USER_BY_FILTER_FAIL;
    payload: string;
}
export interface ResetDcddFilterDataAction {
    type: actionTypes.RESET_DCDD_FILTER_DATA;
}

export type DcddDataReport = 
    | FetchDcddTotalUserRequestAction
    | FetchDcddTotalUserSuccessAction
    | FetchDcddTotalUserFailureAction
    | FetchDcddTotalUserByFilterRequestAction
    | FetchDcddTotalUserByFilterSuccessAction
    | FetchDcddTotalUserByFilterFailureAction
    | ResetDcddFilterDataAction